import { render } from "./RolesTable.vue?vue&type=template&id=3a7cd142&scoped=true"
import script from "./RolesTable.vue?vue&type=script&lang=js"
export * from "./RolesTable.vue?vue&type=script&lang=js"

import "./RolesTable.vue?vue&type=style&index=0&id=3a7cd142&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7cd142"]])

export default __exports__